import { render, staticRenderFns } from "./RecoveryConfirm.vue?vue&type=template&id=e11b9cf4"
import script from "./RecoveryConfirm.vue?vue&type=script&lang=js"
export * from "./RecoveryConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports